<div>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">{{jobCategory}} Import Validation</h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex">
                                    <span class="mx-2 text-primary">Total:
                                        <strong>{{recordStatusObj.totalRecord}}</strong></span>
                                    <span class="mx-2 text-success">Valid:
                                        <strong>{{recordStatusObj.validRecord}}</strong></span>
                                    <span class="mx-2 text-danger">Invalid:
                                        <strong>{{recordStatusObj.invalidRecord}}</strong></span>
                                </div>
                                <!-- <button type="button" class="btn btn-primary btn-sm">
                                <i class="mdi mdi-plus" (click)="porcessImport()" >Process Data</i>
                            </button> -->
                            </div>
                        </div>
                        <div>
                            <div class="row mt-2">
                                <div class="col-md-12 grid-container mb-2">
                                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                        class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                                        [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                        [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                        [enableCellTextSelection]="true" [pagination]="true"
                                        (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>